"use client";

import { useEffect, useRef } from "react";

import { HomeHeroReportPreview } from "~/components/siteglue/home/home-hero-report-preview";
import { HomeHeroScanForm } from "~/components/siteglue/home/home-hero-scan-form";
import { HeroNeuralNetwork } from "~/components/siteglue/landing/hero-neural-network";
import {
  HOMEPAGE_HERO_EYEBROW,
  HOMEPAGE_HERO_H1,
  HOMEPAGE_HERO_SUPPORT,
} from "~/lib/siteglue/landing-redesign/copy";
import { trackLandingEvent } from "~/lib/siteglue/landing-redesign/events";

export function HomeHeroTwoColumn() {
  const ref = useRef<HTMLElement>(null);
  const viewed = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || viewed.current) return;
        viewed.current = true;
        trackLandingEvent("hero_view", { headline_version: "aro_hro_two_column" });
        observer.disconnect();
      },
      { threshold: 0.4 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative isolate overflow-hidden bg-white text-slate-900"
    >
      <HeroNeuralNetwork />
      <div className="relative z-10 mx-auto grid max-w-6xl items-start gap-10 px-4 py-12 sm:px-6 sm:py-16 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-12 lg:py-20">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            {HOMEPAGE_HERO_EYEBROW}
          </p>
          <h1 className="mt-3 text-balance text-[clamp(2rem,3.4vw+0.7rem,3.25rem)] font-semibold leading-[1.08] tracking-tight text-slate-900">
            {HOMEPAGE_HERO_H1}
          </h1>
          <p className="mt-4 max-w-xl text-pretty text-base leading-relaxed text-slate-600 sm:text-lg">
            {HOMEPAGE_HERO_SUPPORT}
          </p>
          <div className="mt-6">
            <HomeHeroScanForm />
          </div>
        </div>
        <div className="min-w-0 lg:sticky lg:top-24">
          <HomeHeroReportPreview />
        </div>
      </div>
    </section>
  );
}
